import _ from 'lodash'
import Wizard from 'scoreboard/components/wizard'
import SetRepeatBy from 'scoreboard/datasets/overview/set-repeat-by-grouping'
import SetRepeatByStep2 from 'scoreboard/datasets/overview/set-repeat-by-grouping-step2'
import { getRepeatByGroupingKey } from 'scoreboard/datasets/overview/get-repeat-by-grouping'

// the wizard starts with one step.  A second may be added later
var ONE_STEP = [ SetRepeatBy ]

var TWO_STEPS = [ SetRepeatBy, SetRepeatByStep2 ]

/**
 * For setting the "Repeat Columns By" or "Repeat Rows By" groupings on a dataset table (#12826)
 */
var RepeatByGroupingWizard = Wizard.extend({

	/**
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model the dataset displayed on the Dataset Overview
	 *
	 * @param {Object} options.table the table whose repeat by groupings are to be customized
	 *
	 * @param {String} options.repeatByType either 'row' or 'column'
	 *
	 * @param {Object} options.suggestions suggestions for any text fields.
	 * Keys are field IDs, and values for the map are the List of suggestions.
	 */
	initialize: function(options) {
		const otherRepeatByType = options.repeatByType === 'row' ? 'column' : 'row'
		var opts = _.extend({
			views: ONE_STEP,
			table: options.table,
			grouping: options.table.get(getRepeatByGroupingKey(options.repeatByType)),
			otherGrouping: options.table.get(getRepeatByGroupingKey(otherRepeatByType))
		}, options)
		Wizard.prototype.initialize.call(this, opts)
	},

	oneStep: function() {
		this.steps = 1
		this.views = ONE_STEP
	},

	twoSteps: function() {
		this.steps = 2
		this.views = TWO_STEPS
	},

	finish: function(grouping) {
		_.invoke(this, 'options.stateSaver')
		this.trigger('done', grouping)
	},

	saveState: function(grouping) {
		this.options.gouping = grouping
	}

})

export default RepeatByGroupingWizard

RepeatByGroupingWizard.__filename__ = 'datasets/overview/repeat-by-grouping-wizard.js'
